import { useCallback, useEffect, useState } from 'react'
import zionDebug from '@fs/zion-debug'
import { i18n } from '@fs/zion-locale'
import { useQueryParams } from '@fs/zion-router'
import { getTempleInfo } from '../lib/services'
import fallbackTempleImg from '../images/backgrounds/temple.webp'

const debug = zionDebug('FirstTimeTempleExperience:useTempleInfo')

export default function useTempleInfo({ dispatch, setErrorType, preLoadTempleInfo } = {}) {
  const [templeInfo, setTempleInfo] = useState(preLoadTempleInfo ?? {})
  const { query } = useQueryParams()
  const { memberUuid } = query ?? {}

  const handleTempleInfo = useCallback((info) => {
    setTempleInfo({ ...info, fallbackTempleImg })
  }, [])

  const handleErrors = useCallback(
    (error) => {
      // If the temple info doesn't return any data, that means the helpee does not have a FamilySearch account
      // Call the endpoint again without the memberUuid
      if (
        memberUuid &&
        (error.response.data.includes('404 : [no body]') ||
          error.response.data.includes('Cannot help a person without a FamilySearch account.') ||
          error.response.status === 403)
      ) {
        // Use the helper's UUID to get temple info instead. They are most likely going to be assigned the same temple
        const { serverPromise, cachePromise } = getTempleInfo(undefined, i18n.language)
        cachePromise.then(handleTempleInfo).catch(handleErrors)
        serverPromise.then(handleTempleInfo).catch(handleErrors)
      } else {
        debug(`The following error occurred while getting the temple info: ${JSON.stringify(error?.response)}`)
        const errorType = error?.response?.status >= 500 ? 'SYSTEM_DOWN' : 'GET_TEMPLE_INFO'
        if (dispatch) dispatch({ type: 'SET_ERROR_TYPE', errorType })
        else setErrorType(errorType)
      }
    },
    [dispatch, handleTempleInfo, memberUuid, setErrorType]
  )

  // Get member's local temple information
  useEffect(() => {
    if (!preLoadTempleInfo && handleErrors && handleTempleInfo) {
      const { serverPromise, cachePromise } = getTempleInfo(memberUuid, i18n.language)
      cachePromise.then(handleTempleInfo).catch(handleErrors)
      serverPromise.then(handleTempleInfo).catch(handleErrors)
    }
  }, [handleErrors, handleTempleInfo, memberUuid, preLoadTempleInfo])

  return templeInfo
}
